jQuery(document).ready(function() {
    /*
	dialog = jQuery("#image_uploader").dialog({
		dialogClass: 'image_uploader',
		autoOpen: false,
		height: 'auto',
		width: 525,
		modal: true,
		buttons: [
			{
				text: (typeof strUseLogo === 'undefined' ? 'OK' : strUseLogo),
				click: upload_image
			},
			{
				text: (typeof strCancel === 'undefined' ? 'Cancel' : strCancel),
				click: function() {
					dialog.dialog("close");
				}
			}
		],
		position: {
			my: "center top+100px",
			at: "center top",
			of: window
		},
		resizable: false,
		open: function() {
			jQuery("#image_uploader").parent().find(".ui-dialog-buttonpane button:first-child").button("disable");
		},
		close: function() {
			jQuery(this).find('#uploadImageFile').val('');
			jQuery(this).find('#imagePreview').hide();
			jQuery(this).find('#imagePreview img').attr('src','');
			jQuery(this).find('#uploadImageFileProgressBar').val(0);		
			jQuery(this).find('#uploadImageFileStatus').html('');
		}
	});
	*/

    if (jQuery('#modal-upload').length) {
        MicroModal.show('modal-upload', {
            onShow: function (modal, trigger) {
                var nbrUploaderID = jQuery('.image_uploader_wrapper .image_uploader_ID').val();
                jQuery("#image_uploader #uploadImageForm").find("input#imageID").val(nbrUploaderID);
            },
            onClose: function (modal, trigger) {
                var objModal = jQuery(modal);
                clear_image(objModal);
            },
        });
    }

    jQuery('#modal-upload .c-modal__close, #modal-upload .c-modal__overlay, #image_uploader #button_use_image_cancel').on('click', function() {
        MicroModal.close('modal-upload');
        clear_image(jQuery('#modal-upload'));
    });

    jQuery('#image_uploader #button_use_image').on('click', function(event) {
        event.stopPropagation();
        event.stopImmediatePropagation();
        upload_image();
    });

	jQuery("#image_uploader #uploadImageFile").on("change", function() {
		jQuery("#image_uploader #uploadImageFileStatus").html("");
		
		var input = jQuery(this)[0];
		var img = jQuery(this).parent().find("#imagePreview");
        
		if (input.files && input.files[0]) {
            jQuery('#image_uploader #button_use_image').attr('disabled', false);
			var reader = new FileReader();

			reader.onload = function (e) {	
				img.find('img').attr('src', e.target.result);
				img.show();
			}

			reader.readAsDataURL(input.files[0]);
        } else {
            jQuery('#image_uploader #button_use_image').attr('disabled', true);
			img.hide();
		}
 	});
});

function clear_image(objModal) {
    objModal.find('#uploadImageFile').val('');
    objModal.find('#imagePreview').hide();
    objModal.find('#imagePreview img').attr('src','');
    objModal.find('#uploadImageFileProgressBar').val(0);
    objModal.find('#uploadImageFileStatus').html('');
    objModal.find('#button_use_image').attr('disabled', true);
}

function delete_image(trigger, imageID) {
    if (jQueryConfirm(trigger, trigger.data('message'), trigger.data('title'), trigger.data('yes'), trigger.data('no'))) {
        var imgUploader = jQuery('input.image_uploader_ID[value=' + imageID + ']').closest('.image_uploader_wrapper');
        if (imgUploader.find('.image_uploader_filename').val() !== '') {
            jQuery.ajax({
                url: '/includes/image_uploader.php',
                type: 'POST',
                data: {
                    'delete': 'delete',
                    'filename': imgUploader.find('.image_uploader_filename').val()
                },
                success: function (data) {
                    if (data.status == true) {
                        imgUploader.find('.image_uploader_filename').val('');
                    }
                }
            });
        } else {
            imgUploader.find('.image_uploader_delete_current').val(1);
        }
        imgUploader.find('.image_uploader_preview img').attr("src", "");
        imgUploader.find('.image_uploader_preview').hide();
        imgUploader.find('.image_uploader_delete').hide();
        imgUploader.find('.image_uploader_has_image').val('');
    }
}

function insert_image(imageID) {
	jQuery("#image_uploader #uploadImageForm").find("input#imageID").val(imageID);
	dialog.dialog('open');
}

function upload_image() {
	if (jQuery("#image_uploader #uploadImageFile").val() == '') {
		jQuery("#image_uploader #uploadImageFileStatus").html(strSelectImageFile);
	} else {
		var file = jQuery("#image_uploader #uploadImageFile")[0].files[0];
		
		if (jQuery.inArray(file.type, [ 'image/png', 'image/jpeg', 'image/pjpeg', 'image/gif', 'image/webp' ]) == -1) {
			jQuery("#image_uploader #uploadImageFileStatus").html(strSelectImageFile);
		}else {
			jQuery("#image_uploader #button_use_image").attr('disabled', true);

			jQuery("#image_uploader #uploadImageFileStatus").html("");
			
			var formData = new FormData(jQuery("#image_uploader #uploadImageForm")[0]);
			
			jQuery.ajax({
				url: '/includes/image_uploader.php',
				type: 'POST',
				xhr: function() {  // Custom XMLHttpRequest
					var myXhr = jQuery.ajaxSettings.xhr();
					if (myXhr.upload) { // Check if upload property exists
						myXhr.upload.addEventListener('progress', upload_image_progressHandler, false); // For handling the progress of the upload
					}
					return myXhr;
				},
				//Ajax events
				success: upload_image_completeHandler,
				error: upload_image_errorHandler,
				// Form data
				data: formData,
				//Options to tell jQuery not to process data or worry about content-type.
				cache: false,
				contentType: false,
				processData: false
			});
		}
	}
}

function upload_image_progressHandler(data){
	var percent = (data.loaded / data.total) * 100;
	jQuery("#image_uploader #uploadImageFileProgressBar").val(Math.round(percent));
}

function upload_image_completeHandler(data){
	if (data.status == true) {
        var imgUploader = jQuery('input.image_uploader_ID[value=' + data.imageID + ']').closest('.image_uploader_wrapper');
        imgUploader.find('.image_uploader_preview img').attr("src", data.imagePath);
		imgUploader.find('.image_uploader_preview').show();
		imgUploader.find('.image_uploader_delete').show();
        imgUploader.find('.image_uploader_filename').val(data.imagePath);
        imgUploader.find('.image_uploader_delete_current').val(1);
        imgUploader.find('.image_uploader_has_image').val('yes');

        MicroModal.close('modal-upload');
        clear_image(jQuery('#modal-upload'));
    } else {
		jQuery("#image_uploader #uploadImageFileStatus").html(data.message);
		jQuery("#image_uploader #uploadImageFileProgressBar").val(0);
		jQuery("#image_uploader #button_use_image").attr('disabled', false);
	}
}

function upload_image_errorHandler(event){
	jQuery("#image_uploader #uploadImageFileStatus").html(strUploadFailed);
	jQuery("#image_uploader #uploadImageFileProgressBar").val(0);
    jQuery("#image_uploader #button_use_image").attr('disabled', false);
}

jQuery(function() {
    jQuery('.image_uploader_delete').on('click', function() {
        var nbrUploaderID = jQuery(this).closest('.image_uploader_wrapper').find('.image_uploader_ID').val();
        delete_image(jQuery(this), nbrUploaderID);
    });

    jQuery('#selectImage').on('click', function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
        jQuery('#uploadImageFile').click();
    })

    jQuery('#uploadImageFile').on('click', function(event) {
       event.stopPropagation();
       event.stopImmediatePropagation();
    });
});